import * as React from "react";
import _ from "lodash";
import { Text } from "recharts";
const d3 = require("d3-format");

export const AxisTick = React.createClass<AxisTickProps, {}>({
  formatAsNumber(value: number) {
    let { prefix } = this.props;
    //https://github.com/d3/d3-format/blob/master/README.md#format:
    //d3 format has a specifier argument which determines the final format of the converted number.
    //it follows these rules.
    //[​[fill]align][sign][symbol][0][width][,][.precision][type]
    //ex.  3,.2 -> the number of characters between delimiters [width] = 3, comma delimiter [,] = , , trailing decimals [.precision] = .2
    let setup = prefix ? `${prefix}.3s` : ".3s";
    let formatter = d3.format(setup);

    // Format and remove trailing zeroes
    let txt = formatStringAsNumber(formatter(value));

    return txt;
  },

  render() {
    const {
      payload: { coordinate, value, index },
      isNumeric,
      interval
    } = this.props;

    // Make a rough estimation of how wide the tick text should be, based on
    // the coordinate of where the tick starts, and the interval that ticks
    // will occur at
    let width = ((interval + 1) * coordinate) / (index + 1);
    if (interval > 0) width = Math.min(width, 100);

    const props = { ...this.props, width };
    const tickLabel = isNumeric
      ? this.formatAsNumber(value)
      : _.startCase(value);
    return (
      <Text {...props} fill="#5D6368;">
        {tickLabel}
      </Text>
    );
  }
});

export const formatStringAsNumber = (txt: string) => {
  const suffixRegex = /([a-zA-Z]\b)/;
  const trailingZeroDecimalRegex = /^(\d+\.\d*?[1-9])0+\b/;
  const zeroDecimalRegex = /(\d+)(\.0+\b)/;
  const suffixTrailingZeroRegex =
    /^(\d+)\.0+(?=[a-zA-Z])|^(\d+\.\d*?)0+(?=[a-zA-Z])/;

  if (suffixRegex.test(txt)) {
    return txt.replace(suffixTrailingZeroRegex, "$1$2");
  } else if (trailingZeroDecimalRegex.test(txt)) {
    return txt.replace(trailingZeroDecimalRegex, "$1");
  } else if (zeroDecimalRegex.test(txt)) {
    return txt.replace(zeroDecimalRegex, "$1");
  }

  return txt;
};



// WEBPACK FOOTER //
// ./client/modules/core/Chart/CartesianChart/common/AxisTick/index.tsx